export const PreLogin = ({ component }) => {
  return <>{component}</>;
};
